import { render, staticRenderFns } from "./paypalButtons.vue?vue&type=template&id=4c6156b3&lang=pug"
import script from "./paypalButtons.vue?vue&type=script&lang=js"
export * from "./paypalButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports